import { Grid, TextField } from '@mui/material'
import { ChangeEvent, useEffect, useRef, useState } from 'react'

import ConfirmationDialog from './ConfirmationDialog'

interface ChangeTextDialogProps {
  open: boolean
  setOpen: (b: boolean) => void
  title: string
  text: string
  onApprove: (s: string) => void
  placeholder: string
}

interface ChangeTextDialogContentProps extends ChangeTextDialogProps {
  onSetText: (s: string) => void
  text: string
}

function ChangeTextDialogContent(props: ChangeTextDialogContentProps) {
  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (!props.open) return

    const timeoutId = setTimeout(() => {
      inputRef.current?.focus()
      const valueLength = inputRef.current?.value.length ?? 0
      inputRef.current?.setSelectionRange(valueLength, valueLength)
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [props.open])

  const onFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onSetText(event.target.value)
  }

  return (
    <Grid item style={{ width: '500px', overflowX: 'hidden' }}>
      <TextField
        inputRef={inputRef}
        variant="outlined"
        placeholder={props.placeholder}
        value={props.text}
        onChange={onFirstNameChange}
        multiline
        rows={4} // Adjust the number of rows as needed
        fullWidth
        sx={{ display: 'block', maxWidth: '100%' }}
      />
    </Grid>
  )
}

export default function ChangeTextDialog(props: ChangeTextDialogProps) {
  const [text, onSetText] = useState(props.text)

  return (
    <ConfirmationDialog
      title={props.title}
      handleClose={() => props.setOpen(false)}
      handleRightButton={() => {
        props.onApprove(text)
        props.setOpen(false)
      }}
      handleLeftButton={() => {
        props.setOpen(false)
      }}
      content={
        <ChangeTextDialogContent {...props} text={text} onSetText={onSetText} />
      }
      open={props.open}
    />
  )
}
